<section id="contact" class="container-fluid pb-5">
    <div class="row">
        <div class="col-sm-12 col-md-6">
            <div class="d-flex align-items-center justify-content-center m-5 p-5">
                <div>
                    <h2>GET IN TOUCH</h2>
                    <p>Company address</p>
                    <p>contact@hills@forest.com</p>
                    <p>222-222-222</p>
                </div>
            </div>
        </div>

        <div class="col-sm-12 col-md-6 mt-5 pe-5">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control" id="floatingInputName" placeholder="John Doe">
                            <label for="floatingInputName">Name</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control" id="floatingInputPhone" placeholder="+63">
                            <label for="floatingInputPhone">Phone</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-floating mb-3">
                            <input type="email" class="form-control" id="floatingInputEmail" placeholder="name@example.com">
                            <label for="floatingInputEmail">Email</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control" id="floatingInputAddress" placeholder="Philippines">
                            <label for="floatingInputAddress">Address</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInputSubject" placeholder="name@example.com">
                        <label for="floatingInputSubject">Subject</label>
                    </div>
                    <div class="form-floating mb-3">
                        <textarea class="form-control" id="floatingInputMessage" placeholder="Type your message here ..." style="height: 10rem;" rows="10"></textarea>
                        <label for="floatingInputMessage">Message</label>
                    </div>
                </div>

                <hr class="my-2">

                <div class="row">
                    <a class="btn">Submit</a>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    #contact {
        background-color: #EFF0F2;
    }
</style>